import { render } from "./Aside.vue?vue&type=template&id=200a128a"
import script from "./Aside.vue?vue&type=script&lang=js"
export * from "./Aside.vue?vue&type=script&lang=js"
script.render = render

export default script